module.exports = __webpack_public_path__ + "img/januca-2016-thumbnail.ff5e9f93.jpeg";